import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {Row, Col} from 'antd';
import Button from '@mui/material/Button';
import {Abc, AddCircleRounded} from "@mui/icons-material";
import BlacklistInstance from "./components/BlacklistInstance";
import { selectAppDataByType } from '../../store/slices/user.slice';
import PageHeader  from "../../layouts/PageHeader";
import {iconMapping} from "../../configs/AppsConfig";
import AppDataCollection from "../../components/AppDataCollection";

/**
 * Page for managing and creating blacklists
 * @returns {JSX.Element}
 * @constructor
 */
const Blacklists = () => {
  const blacklists = useSelector(state => selectAppDataByType(state, 'blacklist'));

  const [activeBlacklist, setActiveBlacklist] = useState(null);
  const [isViewingInstance, setIsViewingInstance] = useState(false);
  const [viewKey, setViewKey] = useState(0);

  const handleSelectBlacklist = (blacklistObject) => {
    setActiveBlacklist(blacklistObject);
    setIsViewingInstance(true);
    setViewKey(viewKey + 1)
  };

  const handleCreateNewBlacklist = () => {
    setActiveBlacklist({
      id: null,
      title: 'New Blacklist',
      data: { items: [] }, // Initialize with any default structure you need
    });
    setIsViewingInstance(true);
  };


  let actions = [
    <Button
        type={'primary'}
        onClick={handleCreateNewBlacklist}
        startIcon={<AddCircleRounded />}
    >
      Create New Blacklist
    </Button>
  ]

  return (
    <div className="blacklist-manager">
        <PageHeader title="Blacklist Manager" actions={actions} logoUrl={iconMapping.blacklist} />
        <div style={{padding: '5% 10%'}}>
          <AppDataCollection data={blacklists} onSelect={handleSelectBlacklist} />
        </div>
        {isViewingInstance && (
            <Row justify={'center'} key={viewKey}>
              <Col flex={'0 0 900px'}>
                <BlacklistInstance blacklist={activeBlacklist} onClose={()=>setIsViewingInstance(false)} />
              </Col>
            </Row>
        )}
    </div>
  );
};

export default Blacklists;
